import { useSelector } from 'react-redux';

import { StoreState } from '~/reducer';
import { languagesStateSelector } from '~/selectors';

import { Language } from './types';

export const useLanguages = (): {
  languages: Language[];
  isLoading: boolean;
  failedToLoad: boolean;
  hasData: boolean;
} => {
  return useSelector((state: StoreState) => {
    return languagesStateSelector(state);
  });
};
